function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqiggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "50px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.42988,0,0,1.42988,-31.6855,-17.7111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.924,29.162C105.516,29.072 105.158,28.974 104.751,28.934C104.633,28.923 104.517,28.924 104.399,28.93C104.127,28.942 103.858,28.988 103.591,29.027C101.818,29.283 100.117,29.752 98.348,30.314C97.799,30.494 97.274,30.684 96.762,30.907C96.248,31.13 95.747,31.385 95.25,31.693C94.867,31.932 94.477,32.195 94.103,32.477C93.726,32.762 93.364,33.065 93.04,33.38L90.925,35.37C91.423,35.056 91.921,34.756 92.405,34.422C92.73,34.198 93.041,33.96 93.347,33.71C93.67,33.421 94.029,33.147 94.401,32.888C94.773,32.63 95.159,32.39 95.537,32.172C96.018,31.894 96.501,31.665 96.996,31.466C97.496,31.266 98.008,31.096 98.542,30.939C100.529,30.332 102.449,29.987 104.441,29.64C104.592,29.613 104.738,29.581 104.885,29.536C105.248,29.427 105.558,29.284 105.924,29.162Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.42988,0,0,1.42988,-31.6855,-17.7111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.092,30.633C35.364,31.139 35.616,31.482 35.909,31.763C36.341,32.176 36.86,32.452 37.66,32.908L41.063,34.504C41.705,34.808 42.413,34.981 43.141,35.072C44.212,35.207 45.325,35.166 46.33,35.126C48.016,35.06 49.715,34.754 51.389,34.241C53.002,33.748 54.588,33.061 56.119,32.241L60.514,29.55C61.478,28.984 62.563,28.444 63.697,27.992C64.795,27.553 65.939,27.197 67.066,26.989C67.999,26.817 68.904,26.937 69.774,27.214C71.145,27.651 72.43,28.476 73.611,29.242C75.736,30.608 78.008,32.854 80.377,33.688C81.601,34.118 82.85,34.192 84.118,33.668L87.85,31.945C88.814,31.48 89.263,31.224 89.711,30.903C90.374,30.428 91.033,29.798 93.5,28.015C93.917,27.722 95.653,26.385 98.063,25.433C99.531,24.853 101.256,24.443 103.053,24.46L105.751,24.833C107.164,25.047 108.473,25.734 109.645,26.556C111.76,28.04 113.446,29.923 114.352,30.659C114.739,30.974 115.051,31.086 115.242,31.032C115.406,30.99 115.505,30.822 115.462,30.658C115.42,30.494 115.252,30.395 115.088,30.438C114.92,30.474 114.711,30.12 114.324,29.678C113.433,28.662 112.145,26.93 110.48,25.487C109.21,24.387 107.726,23.485 106.098,23.084C105.634,22.997 104.944,22.883 104.291,22.824C103.811,22.781 103.351,22.766 103.006,22.787C101.432,22.89 99.939,23.299 98.592,23.822C95.586,24.99 93.338,26.755 92.852,27.121C90.392,28.907 89.736,29.539 89.074,30.014C88.665,30.307 88.253,30.534 87.374,30.958L83.698,32.647C82.356,33.197 81.048,32.869 79.772,32.21C77.832,31.208 75.967,29.451 74.2,28.324C72.933,27.522 71.549,26.67 70.084,26.221C69.051,25.905 67.979,25.784 66.878,26C65.69,26.234 64.485,26.619 63.333,27.098C62.16,27.585 61.042,28.169 60.05,28.775L55.727,31.529C54.258,32.36 52.729,33.053 51.175,33.577C49.567,34.121 47.933,34.485 46.301,34.605C45.321,34.677 44.235,34.755 43.185,34.661C42.494,34.6 41.818,34.465 41.2,34.2L37.748,32.746C36.942,32.328 36.419,32.078 35.978,31.688C35.679,31.424 35.419,31.097 35.132,30.61C35.126,30.599 35.112,30.595 35.101,30.602C35.09,30.608 35.086,30.622 35.092,30.633Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.64924,0,0,4.70504,-521.907,-122.11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.478,
    cy: 32.607,
    rx: 0.501,
    ry: 0.558,
    style: {
      fill: "rgb(241,17,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.64924,0,0,4.70504,-642.808,-128.346)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.478,
    cy: 32.607,
    rx: 0.501,
    ry: 0.558,
    style: {
      fill: "rgb(08,0,102)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.58143,0,0,5.7963,-614.628,-159.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.881,32.368C114.082,32.368 114.245,32.555 114.245,32.784C114.245,33.014 114.082,33.201 113.881,33.201C113.68,33.201 113.516,33.014 113.516,32.784C113.516,32.555 113.68,32.368 113.881,32.368ZM113.881,32.576C113.981,32.576 114.063,32.67 114.063,32.784C114.063,32.899 113.981,32.992 113.881,32.992C113.78,32.992 113.699,32.899 113.699,32.784C113.699,32.67 113.78,32.576 113.881,32.576Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.58143,0,0,7.02677,-736.034,-205.595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.881,32.368C114.082,32.368 114.245,32.555 114.245,32.784C114.245,33.014 114.082,33.201 113.881,33.201C113.68,33.201 113.516,33.014 113.516,32.784C113.516,32.555 113.68,32.368 113.881,32.368ZM113.881,32.576C113.981,32.576 114.063,32.67 114.063,32.784C114.063,32.899 113.981,32.992 113.881,32.992C113.78,32.992 113.699,32.899 113.699,32.784C113.699,32.67 113.78,32.576 113.881,32.576Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqiggle);
export default __webpack_public_path__ + "static/media/sqiggle.170d8108fcc95e51b8c5e036be884df3.svg";
export { ForwardRef as ReactComponent };